var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGCalificaciones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.6,23.2H9.5a.8.8,0,0,1-.7-.8l.6-7.6H9.2a.9.9,0,0,1-.3-1.1l.7-1.5a1,1,0,0,1,1-.4.8.8,0,0,1,.5.9l-.7,9.8A.8.8,0,0,1,9.6,23.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.4,28.3a8.1,8.1,0,0,1-6-2.2c-4-4.6.5-11.6.7-11.9C11,2.7,18.6,3.7,19,3.7a4.1,4.1,0,0,1,3,1.8c1.2,1.9.3,4.6.3,4.7-2.3,8.3-5.4,9-6.2,9a2.3,2.3,0,0,1-1.7-.3,3.6,3.6,0,0,1-1.1-2.4c-.4-3.2,1.6-6.4,1.6-6.6a.8.8,0,0,1,1.4.8c0,.1-1.7,3-1.4,5.6a2.4,2.4,0,0,0,.5,1.3h.7s2.5-.2,4.6-7.9a4.5,4.5,0,0,0-.1-3.4,2.5,2.5,0,0,0-1.9-1s-7-.8-14.2,9.8c-.1,0-4.1,6.3-.8,10s8.7,1.8,13.2-.7S29.8,15,29.9,15s.9-.3,1.1.1a.7.7,0,0,1-.1,1.1,130.2,130.2,0,0,1-13.2,9.6A21.2,21.2,0,0,1,8.4,28.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGCalificaciones);
export default __webpack_public_path__ + "static/media/g-calificaciones.23d6fbcc.svg";
export { ForwardRef as ReactComponent };